import axiosInstance from './axiosInstance';

const contactMessageService = {
  list:       (params = {}) => axiosInstance.get('/admin/contact-messages', { params }),
  getById:    (id)          => axiosInstance.get(`/admin/contact-messages/${id}`),
  update:     (id, data)    => axiosInstance.put(`/admin/contact-messages/${id}`, data),
  remove:     (id)          => axiosInstance.delete(`/admin/contact-messages/${id}`),
  getStats:   ()            => axiosInstance.get('/admin/contact-messages/stats'),
};

export default contactMessageService;
